import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
/**
 * StringList Component
 * @param {String} label         - Label to display before the string list
 * @param {Array} items          - Array of items to display as unbroken strings in the string list
 * @param {String} processor     - Function that will convert each array item into a string
 * @param {Object} theme         - Theme override sent through CSS Themr
 * @returns {Component}          - React Component
 */

const StringList = ({ theme, label, items, processor, className }) => {
  if (!items || items.length <= 0) return null;
  const processedItems = _.map(items, item => processor(item));
  const displayItems = _.filter(processedItems, _.isString);
  if (displayItems.length === 0) return null;

  return (
    <div className={classNames(theme.list, className)}>
      {label ? <span className={theme.label}>{label} </span> : null}
      {_.map(displayItems, (item, index) => (
        <span key={`${item}-${index}`} className={theme.item}>
          {item}
        </span>
      ))}
    </div>
  );
};

StringList.defaultProps = {
  label: null,
  className: '',
  items: [],
  processor: () => {},
};

StringList.propTypes = {
  theme: PropTypes.shape({}).isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.string),
  processor: PropTypes.func,
};

export default StringList;
